/**
 * SEVO Gallery Lightbox
 * Premium zoom/lightbox experience for product images
 */

(function() {
  'use strict';

  window.SEVO = window.SEVO || {};

  window.SEVO.Lightbox = {
    overlay: null,
    imageEl: null,
    counterEl: null,
    images: [],
    currentIndex: 0,

    init: function() {
      // Only initialize on product pages with gallery
      const gallery = document.querySelector('[data-product-gallery]');
      if (!gallery) return;

      this.createOverlay();
      this.bindEvents(gallery);
    },

    createOverlay: function() {
      // Don't create if already exists
      if (document.querySelector('.lightbox-overlay')) return;

      const overlay = document.createElement('div');
      overlay.className = 'lightbox-overlay';
      overlay.innerHTML = `
        <div class="lightbox-content">
          <img class="lightbox-image" src="" alt="" />
        </div>
        <button class="lightbox-close" aria-label="Close lightbox">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
        <button class="lightbox-nav lightbox-nav--prev" aria-label="Previous image">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button class="lightbox-nav lightbox-nav--next" aria-label="Next image">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
        <div class="lightbox-counter"></div>
      `;

      document.body.appendChild(overlay);

      this.overlay = overlay;
      this.imageEl = overlay.querySelector('.lightbox-image');
      this.counterEl = overlay.querySelector('.lightbox-counter');
    },

    bindEvents: function(gallery) {
      // Collect all gallery images
      const slides = gallery.querySelectorAll('.product-gallery__slide img');
      this.images = Array.from(slides).map(img => ({
        src: img.dataset.zoomSrc || img.src.replace(/&width=\d+/, '&width=1500'),
        alt: img.alt
      }));

      // Click on gallery slides to open
      slides.forEach((img, index) => {
        const slide = img.closest('.product-gallery__slide');
        if (slide) {
          slide.addEventListener('click', (e) => {
            e.preventDefault();
            this.open(index);
          });
        }
      });

      // Close button
      const closeBtn = this.overlay.querySelector('.lightbox-close');
      closeBtn.addEventListener('click', () => this.close());

      // Click overlay to close
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay || e.target.classList.contains('lightbox-content')) {
          this.close();
        }
      });

      // Navigation buttons
      const prevBtn = this.overlay.querySelector('.lightbox-nav--prev');
      const nextBtn = this.overlay.querySelector('.lightbox-nav--next');
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.prev();
      });
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.next();
      });

      // Keyboard navigation - store handler so it can be removed on close
      this._keydownHandler = (e) => {
        if (e.key === 'Escape') {
          this.close();
        } else if (e.key === 'ArrowLeft') {
          this.prev();
        } else if (e.key === 'ArrowRight') {
          this.next();
        }
      };

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.overlay.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.overlay.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      }, { passive: true });
    },

    open: function(index) {
      this.currentIndex = index;
      this.updateImage();
      this.overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';

      // Add keyboard listener when lightbox opens
      if (this._keydownHandler) {
        document.addEventListener('keydown', this._keydownHandler);
      }

      // Focus trap
      this.overlay.querySelector('.lightbox-close').focus();
    },

    close: function() {
      this.overlay.classList.remove('is-active');
      document.body.style.overflow = '';

      // Remove keyboard listener when lightbox closes
      if (this._keydownHandler) {
        document.removeEventListener('keydown', this._keydownHandler);
      }
    },

    prev: function() {
      this.currentIndex = this.currentIndex > 0
        ? this.currentIndex - 1
        : this.images.length - 1;
      this.updateImage();
    },

    next: function() {
      this.currentIndex = this.currentIndex < this.images.length - 1
        ? this.currentIndex + 1
        : 0;
      this.updateImage();
    },

    updateImage: function() {
      const image = this.images[this.currentIndex];
      if (!image) return;

      // Fade out, update, fade in
      this.imageEl.style.opacity = '0';

      setTimeout(() => {
        this.imageEl.src = image.src;
        this.imageEl.alt = image.alt;
        this.imageEl.style.opacity = '';
      }, 150);

      // Update counter
      this.counterEl.textContent = `${this.currentIndex + 1} / ${this.images.length}`;

      // Hide nav if only one image
      const navBtns = this.overlay.querySelectorAll('.lightbox-nav');
      navBtns.forEach(btn => {
        btn.style.display = this.images.length > 1 ? '' : 'none';
      });
    }
  };

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.SEVO.Lightbox.init();
    });
  } else {
    window.SEVO.Lightbox.init();
  }

  // Re-initialize on Shopify section reload
  document.addEventListener('shopify:section:load', () => {
    window.SEVO.Lightbox.init();
  });
})();
